import classNames from "classnames";
import React, { ReactNode, useEffect, useState } from "react";
import usePagination from "../hooks/usePagination";

type PaginationProps = {
	totalRecords: number;
	perPageCount: number;
	reset:boolean;
    setPerPageDataSet:(start:number, end:number)=>void;
	// currentPage: number;
};
export default function Pagination({
	totalRecords,
	perPageCount,
	reset,
    setPerPageDataSet,
}: PaginationProps) {
	const [currentPage, setCurrentPage] = useState(1);
    const {pageStart,
		pageEnd,
		noOfPages,
        current,
        moveTo} = usePagination(totalRecords, perPageCount, currentPage, reset)
		
	const [numbering, setNumering] = useState<ReactNode[]>([]);


    useEffect(()=>{
        setCurrentPage(current)
    },[current]);

    useEffect(()=>{
        setPerPageDataSet(pageStart,pageEnd);
	},[pageStart,pageEnd, setPerPageDataSet]);

	useEffect(() => {
		let elems: ReactNode[] = [];
		for (let i = 1; i <= noOfPages; i++) {
			elems.push(
					<button
						type="button"
					aria-current="page"
                    key={i}
                    onClick={()=>moveTo((i))}
						className={classNames(currentPage === i?"bg-primary-50 dark:bg-slate-700/80 text-primary-100 dark:text-white":null,
						`relative z-10 inline-flex items-center 
                        px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-slate-700/60 focus:z-20 
                        focus-visible:outline focus-visible:outline-2 
                        focus-visible:outline-offset-2 focus-visible:outline-primary-70 rounded-md`,
					)}
				>
					{i}
					</button>,
			);
		}
		setNumering(elems);
		}, [noOfPages, currentPage, moveTo]);


	return (
		<div className="flex items-center justify-between border-t border-gray-200 dark:border-white/10 bg-white/80 dark:bg-slate-900/70 px-4 py-3 sm:px-6 backdrop-blur-sm">
			<div className="flex flex-1 justify-between sm:hidden">
				<button
					type="button"
					onClick={() => moveTo(Math.max(currentPage - 1, 1))}
					className="relative inline-flex items-center rounded-md border border-gray-300 dark:border-white/15 bg-white dark:bg-slate-800/80 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-slate-700/80"
				>
					Previous
				</button>
				<button
					type="button"
					onClick={() => moveTo(Math.min(currentPage + 1, noOfPages))}
					className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 dark:border-white/15 bg-white dark:bg-slate-800/80 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-slate-700/80"
				>
					Next
				</button>
			</div>
			<div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
				<div>
					<p className="text-sm text-gray-700 dark:text-gray-300">
						Showing
						<span className="font-semibold text-gray-900 dark:text-gray-100"> {pageStart} </span>
						to
						<span className="font-semibold text-gray-900 dark:text-gray-100"> {pageEnd} </span>
						of
						<span className="font-semibold text-gray-900 dark:text-gray-100"> {totalRecords} </span>
						results
					</p>
				</div>
				<div>
					<nav
						className="isolate inline-flex -space-x-px rounded-md shadow-sm"
						aria-label="Pagination"
					>
						<button
							type="button"
							onClick={() => moveTo(Math.max(currentPage - 1, 1))}
							className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-500 dark:text-gray-300 ring-1 ring-inset ring-gray-300 dark:ring-white/15 hover:bg-gray-50 dark:hover:bg-slate-700/70 focus:z-20 focus:outline-offset-0"
						>
							<span className="sr-only">Previous</span>
							<svg
								className="h-5 w-5"
								viewBox="0 0 20 20"
								fill="currentColor"
								aria-hidden="true"
								data-slot="icon"
							>
								<path
									fillRule="evenodd"
									d="M11.78 5.22a.75.75 0 0 1 0 1.06L8.06 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"
									clipRule="evenodd"
								/>
							</svg>
						</button>
						{numbering}

						<button
							type="button"
							onClick={() => moveTo(Math.min(currentPage + 1, noOfPages))}
							className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-500 dark:text-gray-300 ring-1 ring-inset ring-gray-300 dark:ring-white/15 hover:bg-gray-50 dark:hover:bg-slate-700/70 focus:z-20 focus:outline-offset-0"
						>
							<span className="sr-only">Next</span>
							<svg
								className="h-5 w-5"
								viewBox="0 0 20 20"
								fill="currentColor"
								aria-hidden="true"
								data-slot="icon"
							>
								<path
									fillRule="evenodd"
									d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
									clipRule="evenodd"
								/>
							</svg>
						</button>
					</nav>
				</div>
			</div>
		</div>
	);
}
